import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import i18next from 'i18next'
import { withNamespaces } from 'react-i18next';

import PunchCCQDay from '@components/punchCCQ/PunchCCQDay';
import PunchCCQWeek from '@components/punchCCQ/PunchCCQWeek';
import PunchCCQProject from '@components/punchCCQ/PunchCCQProject';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabPanelPunchCCQ() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const punchCCQDayClick = () => {
        setIndex(0);
    }

    const punchCCQWeekClick = () => {
        setIndex(1);
    }

    const punchCCQProjectClick = () => {
        setIndex(2);
    }

    return (
        <div data-id="headerPunch" className={classes.root}>
            <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="standard"
                    indicatorColor="primary"
                    textColor="primary"
                    className={"TabPage"}
                >
                    <Tab className={"TabPageButton"} label={i18next.t('punchCCQ:tabPanel.day')} {...a11yProps(0)} onClick={punchCCQDayClick} />
                    <Tab className={"TabPageButton"} label={i18next.t('punchCCQ:tabPanel.week')} {...a11yProps(1)} onClick={punchCCQWeekClick} />
                    <Tab className={"TabPageButton"} label={i18next.t('punchCCQ:tabPanel.project')} {...a11yProps(2)} onClick={punchCCQProjectClick} />
                </Tabs>
            </AppBar>

            {index == 0 && <PunchCCQDay />}
            {index == 1 && <PunchCCQWeek />}
            {index == 2 && <PunchCCQProject />}
        </div>
    );
}

export default withNamespaces(['punchCCQ', 'punch'], { wait: true })(TabPanelPunchCCQ);